/**
 * Detects if Firebase / Google APIs are blocked by an ad-blocker, browser
 * tracking protection, corporate firewall, or similar.
 *
 * Strategy: try a tiny GET to firebaseinstallations.googleapis.com (which
 * the Firebase SDK uses on startup anyway). If we get either a real HTTP
 * response (any 4xx/5xx counts) or a successful response, we know the
 * network reaches Google. If the fetch throws "Failed to fetch" /
 * TypeError, that's the fingerprint of an ad-blocker or tracking
 * protection silently dropping the request.
 *
 * Returns: 'ok' | 'blocked' | 'unknown'
 */
export async function probeFirebaseReachability() {
  // Use a static asset on Google's CDN that reliably returns 200.
  // gstatic.com is on the same DNS umbrella as googleapis.com, so most
  // blockers that swallow Firestore writes also swallow this. If this
  // succeeds, the user's browser can reach Google's infrastructure.
  // Returns 200 → no 4xx console noise.
  const url = 'https://www.gstatic.com/firebasejs/12.0.0/firebase-app-compat.js';
  try {
    await fetch(url, { method: 'GET', mode: 'no-cors', cache: 'no-store' });
    return 'ok';
  } catch (err) {
    // Network errors (ad-blocker, offline, corporate firewall) throw
    // TypeError with names like "Failed to fetch" / "NetworkError".
    if (err instanceof TypeError) return 'blocked';
    return 'unknown';
  }
}
